import { getApiInstance } from 'store/helpers';
import { statuses } from 'store/models/Statuses';
import {
  LoadWorkdeskTicketsParams,
  IdBodyHtmlAndOtherResI,
  WorkdeskTicketsResponse,
} from 'store/models/workdesk-tickets/workdesk-tickets.interface';

/**
 * for all the ticket ids load the email bodies
 * expected returns { <ticketId>: <emailBody> }
 */
const loadAllBodyHtmls = (
  ticketIds: string[],
): Promise<IdBodyHtmlAndOtherResI | []> => {
  return getApiInstance()
    .post('/ticket/getEmailInfo', { ticketIds: ticketIds })
    .then((res: { data: IdBodyHtmlAndOtherResI }) => {
      console.info('/ticket/getEmailInfo', res);
      if (!res.data) {
        console.error(
          `/ticket/getEmailInfo's res.data is not an object`,
        );
        return [];
      }
      return res.data;
    });
};

const loadWorkdeskTickets = (
  params: LoadWorkdeskTicketsParams,
): Promise<WorkdeskTicketsResponse> => {
  console.time(`** TIME ** rest api: /ticket/list`);
  return getApiInstance()
    .post('/ticket/list', params)
    .then((res) => {
      console.info('/ticket/list', res);
      // let's filter non correct statuses for now. but in the future shouldn't have these statuses

      let formattedTickets = res.data.tickets.filter((ticket) =>
        statuses.includes(ticket.status),
      );

      console.timeEnd(`** TIME ** rest api: /ticket/list`);
      const toRet = {
        ...res.data,
        tickets: formattedTickets,
      };
      console.info(
        'rest api: call loadWorkdeskTickets service with params ',
        params,
        'result: ',
        toRet,
      );
      return toRet;
    });
};

export const workdeskTicketsService = {
  loadWorkdeskTickets,
  loadAllBodyHtmls,
};
